<template>
    <form>
        <dx-validation-group :ref="`validationGroup`">
            <rd-popup-content>
                <div class="row">
                    <rd-column :size="$columns.TwelveOnLg">
                        <rd-form-group :label="$t('edit.label.group')">
                            <dx-text-box v-model="Group">
                                <dx-validator>
                                    <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                </dx-validator>
                            </dx-text-box>
                        </rd-form-group>
                    </rd-column>
                    <rd-column :size="$columns.TwelveOnLg">
                        <rd-form-group :label="$t('edit.label.rate')">
                            <dx-number-box :min="0"
                                           :max ="1"
                                         v-model="Rate">
                                <dx-validator>
                                    <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                </dx-validator>
                            </dx-number-box>
                        </rd-form-group>
                    </rd-column>
                    <rd-column :size="$columns.TwelveOnLg">
                        <rd-form-group :label="$t('edit.label.isActive')"  input-type="checkbox">
                            <dx-check-box :value="false" v-model="IsActive"/>
                        </rd-form-group>
                    </rd-column>
                    <rd-column :size="$columns.TwelveOnLg">
                        <rd-form-group :label="$t('edit.label.description')">
                            <dx-text-box v-model="Description"/>
                        </rd-form-group>
                    </rd-column>
                </div>
            </rd-popup-content>
            <rd-popup-actions>
                <dx-button :use-submit-behavior="false"
                           styling-mode="text"
                           type="normal"
                           :text="$t('buttons.cancel')"
                           @click="closePopup">
                </dx-button>
                <dx-button :use-submit-behavior="true"
                           type="default"
                           class="ml-1"
                           :text="$t('buttons.save')"
                           @click="closePopupOnSave">
                </dx-button>
            </rd-popup-actions>
        </dx-validation-group>
    </form>
</template>

<script>
    // @ is an alias to /src
    import DxTextBox from 'devextreme-vue/text-box';
    import DxButton from 'devextreme-vue/button';
    import { DxValidator, DxRequiredRule } from 'devextreme-vue/validator';
    import { DxNumberBox } from 'devextreme-vue/number-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import DxValidationGroup from 'devextreme-vue/validation-group';

    import { mapGetters, mapActions } from 'vuex';
    import { mapFields } from 'vuex-map-fields';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    const name = "administrationStores/dictionariesStores/vatRatesStores/editStore";

    export default {
        name: 'vatRateEdit',
        data() {
            return {
                pageSizes: [5, 10, 15]
            }
        },
        computed: {
            ...mapGetters(name, ['getForm']),
            ...mapFields(name, [
                'editForm.Id',
                'editForm.Group',
                'editForm.Rate',
                'editForm.IsActive',
                'editForm.Description',
            ]),
        },
        methods: {
            ...mapActions(name, ['setEditDetails', 'editVatRate']),
            closePopup: function () {
                this.$emit('closeEdit');
            },
            closePopupOnSave: function (e) {
                let validateResult = e.validationGroup.validate()
                if (validateResult.isValid) {
                    this.$emit('closeEdit');
                    this.editVatRate();
                }
            }
        },
        mounted() {
            this.$refs["validationGroup"].instance.validate();
            //this.setEditDetails();
        },
        components: {
            DxTextBox,
            DxNumberBox,
            DxCheckBox,
            DxButton,
            DxValidator,
            DxRequiredRule,
            DxValidationGroup
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>
